<!-- mantenedor-payku.component.html -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px', fullScreenBackdrop: true }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate> </ng-template>
<ng-template #paykuInfoCards>
	<div class="payku-info-stack">
		<div class="payku-info-card">
			<div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
				<h6 class="payku-info-card__title mb-0">
					<i class="fas fa-percent me-2 text-primary"></i>
					Tarifas y comisiones
				</h6>
				<a class="payku-info-card__link" href="https://payku.com/tarifas/" target="_blank" rel="noopener">Ver tarifas Payku</a>
			</div>

			<div class="payku-benefit-banner mb-3">
				<div class="payku-benefit-banner__icon">
					<i class="fas fa-bolt"></i>
				</div>
				<div class="payku-benefit-banner__content">
					<div class="payku-benefit-banner__title">Beneficio SimpleFactura</div>
					<div class="payku-benefit-banner__text">Te abonamos al <strong>día hábil siguiente</strong>, aplicando la <strong>tarifa reducida del tercer día hábil siguiente</strong>.</div>
				</div>
			</div>

			<div class="table-responsive payku-rates-table-wrapper">
				<table class="table align-middle mb-0 payku-rates-table">
					<thead>
						<tr>
							<th class="medio-pago">Medio de pago</th>
							<th class="col-next-day">
								<div class="col-header-content">
									<i class="fas fa-ban me-1 opacity-75"></i>
									<div>
										<div>Día hábil siguiente</div>
										<small class="col-header-note">Abono estándar</small>
									</div>
								</div>
							</th>
							<th class="col-third-day">
								<div class="col-header-content">
									<div>
										<div>Tercer día hábil siguiente</div>
										<small class="col-header-note">Tarifa aplicada</small>
									</div>
								</div>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								<div class="payment-method-cell">
									<span>Tarjetas Débito / Crédito</span>
									<img src="assets/media/medioPagoPayku/payment-cards.png" alt="Tarjetas Débito / Crédito" class="payment-logo">
								</div>
							</td>
							<td class="price-next-day">
								<span class="price-crossed">2.99% + IVA</span>
								<i class="fas fa-arrow-right price-arrow ms-2"></i>
							</td>
							<td class="price-third-day">2.79% + IVA</td>
						</tr>
						<tr>
							<td>
								<div class="payment-method-cell">
									<span>Mach</span>
									<img src="assets/media/medioPagoPayku/machbank.png" alt="Mach" class="payment-logo">
								</div>
							</td>
							<td class="price-next-day">
								<span class="price-crossed">1.99% + IVA</span>
								<i class="fas fa-arrow-right price-arrow ms-2"></i>
							</td>
							<td class="price-third-day">1.79% + IVA</td>
						</tr>
						<tr>
							<td>
								<div class="payment-method-cell">
									<span>Floid</span>
									<img src="assets/media/medioPagoPayku/floid.svg" alt="Floid" class="payment-logo">
								</div>
							</td>
							<td class="price-next-day">
								<span class="price-crossed">1.99% + IVA</span>
								<i class="fas fa-arrow-right price-arrow ms-2"></i>
							</td>
							<td class="price-third-day">1.79% + IVA</td>
						</tr>
						<tr>
							<td>
								<div class="payment-method-cell">
									<span>Fintoc</span>
									<img src="assets/media/medioPagoPayku/fintoc.svg" alt="Fintoc" class="payment-logo">
								</div>
							</td>
							<td class="price-next-day">
								<span class="price-crossed">1.99% + IVA</span>
								<i class="fas fa-arrow-right price-arrow ms-2"></i>
							</td>
							<td class="price-third-day">1.79% + IVA</td>
						</tr>
						<tr>
							<td>
								<div class="payment-method-cell">
									<span>etpay</span>
									<img src="assets/media/medioPagoPayku/etpay.png" alt="etpay" class="payment-logo">
								</div>
							</td>
							<td class="price-next-day">
								<span class="price-crossed">1.99% + IVA</span>
								<i class="fas fa-arrow-right price-arrow ms-2"></i>
							</td>
							<td class="price-third-day">1.79% + IVA</td>
						</tr>
						<tr>
							<td>
								<div class="payment-method-cell">
									<span>Pago46</span>
									<img src="assets/media/medioPagoPayku/pago46.png" alt="Pago46" class="payment-logo">
								</div>
							</td>
							<td class="price-next-day">
								<span class="price-crossed">2.99% + IVA</span>
								<i class="fas fa-arrow-right price-arrow ms-2"></i>
							</td>
							<td class="price-third-day">2.79% + IVA</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</ng-template>

<!-- Sin cuenta activa -->
<div *ngIf="!hasActiveAccount" class="container-fluid payku-main-container">
	<div class="row">
		<div class="col-12 header-container">
			<h3 class="mb-2">Payku</h3>
			<p class="text-muted mb-4">Configura tu integración con Payku y crea tu cuenta si aún no la tienes.</p>
		</div>
	</div>

	<div class="row">
		<div class="col-lg-6 mb-4">
			<div class="card h-100">
				<div class="card-body">
					<div class="mb-4">
						<h5 class="card-title mb-4">Crear cuenta Payku</h5>
						<p class="mb-0">¿Tienes dudas? <a href="https://youtu.be/gjUEX4iT8W8" target="_blank">Mira el Video</a> o <a href="https://drive.google.com/file/d/15lkxEmJvSSnu7ilqEZPLuv8ulVWbpKbX/view?usp=drive_link" target="_blank">Revisa el Manual</a> para más información.</p>
					</div>
					<div class="mb-4">
						<app-payku-create-button></app-payku-create-button>
					</div>
					<div class="payku-feature-card payku-feature-card--plain">
						<p class="payku-feature-text mb-2"> <strong>Importante: </strong>La alianza entre SimpleFactura y Payku te permite ofrecer pago online en tus documentos con link o QR.</p>
					</div>
				</div>
			</div>
		</div>

		<!-- Estado e información -->
		<div class="col-lg-6 mb-4">
			<div class="card h-100">
				<div class="card-body">
					<h5 class="card-title">Documentación</h5>

					<div class="row g-4">
						<!-- Video -->
						<div class="col-md-6">
							<div class="media-tile media-tile-video">
								<iframe class="media-iframe" src="https://www.youtube-nocookie.com/embed/gjUEX4iT8W8?autoplay=1&mute=1&rel=0&showinfo=0&controls=1&modestbranding=1&iv_load_policy=3&fs=0" title="Video: Crear cuenta Payku" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="lazy"></iframe>
							</div>
							<div class="media-caption">Video</div>
						</div>

						<!-- PDF -->
						<div class="col-md-6 d-flex flex-column">
							<div class="media-tile flex-grow-1">
								<iframe class="media-iframe" style="border-radius: 8px; zoom: 0.85; -ms-zoom: 0.85" src="https://drive.google.com/file/d/15lkxEmJvSSnu7ilqEZPLuv8ulVWbpKbX/preview?rm=minimal" title="Manual Payku (PDF)" loading="lazy"></iframe>
							</div>
							<div class="text-end mt-2">
								<a class="media-link" href="https://drive.google.com/file/d/15lkxEmJvSSnu7ilqEZPLuv8ulVWbpKbX/view?usp=drive_link" target="_blank" rel="noopener">Abrir PDF en nueva pestaña</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="row">
		<div class="col-12 mb-4">
			<ng-container *ngTemplateOutlet="paykuInfoCards"></ng-container>
		</div>
	</div>
</div>

<!-- Con cuenta activa -->
<div *ngIf="hasActiveAccount" class="container-fluid py-4 active-account-container">
	<!-- Encabezado -->
	<div class="row">
		<div class="col-12 header-container">
			<div [ngClass]="{ 'd-none': activeView !== 'panel-abonos' }">
				<h3 class="mb-2">Mis Abonos</h3>
				<p class="text-muted mb-4">Revisa el detalle de tus abonos y descarga los comprobantes de venta.</p>
			</div>
			<div [ngClass]="{ 'd-none': activeView !== 'administrador' }">
				<h3 class="mb-2">Administrador</h3>
				<p class="text-muted mb-4">Configura y administra tu cuenta Payku desde aquí.</p>
			</div>
			<div [ngClass]="{ 'd-none': activeView !== 'detalle-transacciones' }">
				<h3 class="mb-2">Detalle de Transacciones</h3>
				<p class="text-muted mb-4">Transacciones para la fecha: {{ detailDate | date: "dd/MM/yyyy" }}</p>
			</div>
		</div>
	</div>

	<!-- Tabs (ocultar en detalle) -->
	<div class="row mb-4" *ngIf="activeView !== 'detalle-transacciones'">
		<div class="col-12">
			<ul class="nav nav-tabs">
				<li class="nav-item">
					<a class="nav-link" [class.active]="activeView === 'administrador'" (click)="setActiveView('administrador')" style="cursor: pointer"> <i class="fas fa-cog me-2 mr-2 icon-administrador"></i>Administrador </a>
				</li>
				<li class="nav-item">
					<a class="nav-link" [class.active]="activeView === 'panel-abonos'" (click)="setActiveView('panel-abonos')" style="cursor: pointer"> <i class="fas fa-chart-bar me-2 mr-2 icon-panel"></i>Panel de Abonos </a>
				</li>
			</ul>
		</div>
	</div>

	<!-- Cabecera de botones en Detalle (volver) -->
	<div class="row mb-4" *ngIf="activeView === 'detalle-transacciones'">
		<div class="col-12 d-flex align-items-center flex-wrap gap-2">
			<button class="btn btn-outline-primary" (click)="backToPanelAbonos()"><i class="fas fa-arrow-left me-2"></i>Volver al Panel de Abonos</button>
		</div>
	</div>

	<div class="views-container">
		<!-- Panel Abonos -->
		<div *ngIf="activeView === 'panel-abonos' && permissions.getPermission('83-18').asignado" class="view-content">
			<!-- Barra superior -->
			<div class="row mb-4 col-12">
				<div class="col-md-12">
					<div class="d-flex align-items-center">
						<span class="me-2 mr-2">Buscador de abonos: </span>
						<div style="max-width: 180px; width: 100%">
							<input type="date" class="form-control" [(ngModel)]="currentSearchDate" (change)="searchAbonos(currentSearchDate)" [attr.min]="minSearchDate || null" />
						</div>
						<!-- Botón movido completamente a la derecha -->
						<div class="ms-auto">
							<button class="btn btn-outline-primary" (click)="downloadMassiveExtraction()"><i class="fas fa-download me-2"></i>Extracción masiva</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Resumen por día -->
			<div class="row mb-2">
				<div class="col-12">
					<h5 class="mb-3">Resumen por día</h5>
					<p class="text-muted mb-0">Estás viendo el resumen de la fecha consultada y próximos días</p>
				</div>
			</div>

			<!-- Subtítulo ABONOS + info -->
			<div class="row align-items-center mt-3 mb-2">
				<div class="col-12 d-flex align-items-center">
					<h4 class="mb-0 me-2">Abonos</h4>
					<i class="fas fa-circle-info text-muted" [ngbPopover]="abonosInfo" popoverTitle="¿Qué estás viendo?" triggers="mouseenter:mouseleave" placement="right" [popoverClass]="'payku-popover'"> </i>
					<ng-template #abonosInfo>
                        <small>Se distinguen el cobro bruto, el neto estimado y el monto informado por Payku. La fecha estimada usa días hábiles configurados; el reporte Payku no prueba por sí solo el abono bancario.</small>
					</ng-template>
				</div>
			</div>

			<!-- Tarjetas diarias (4) -->
			<div class="row mb-5 summary-cards-container">
				<div class="col-lg-3 col-md-6 mb-3" *ngFor="let card of dailyCards">
					<div class="card h-100" [ngClass]="{ 'bg-primary text-white': card.role === 'today', border: card.role !== 'today' }">
						<div class="card-body">
							<div class="d-flex justify-content-between align-items-start mb-2">
								<h6 class="card-subtitle" [ngClass]="{ 'text-muted': card.role !== 'today' }">
									{{ card.label }}
								</h6>
								<span class="badge" [ngClass]="{ 'bg-white text-dark fw-bold': card.role === 'today', 'bg-light': card.role !== 'today' }">
									{{ card.date }}
								</span>
							</div>

                            <div class="small">Cobrado bruto: <strong>$ {{ card.gross }}</strong></div>
                            <div class="small">Neto estimado: <strong>$ {{ card.estimated }}</strong></div>
                            <div class="small">{{ card.incomplete ? 'Subtotal conocido' : 'Informado por Payku' }}: <strong>$ {{ card.reported }}</strong></div>
                              <div class="small text-warning" *ngIf="card.incomplete">Subtotal conocido: {{ card.incomplete }} liquidación(es) sin importe. No equivale a cero recibido.</div>
                            <div class="mt-2">
                                <span class="badge" [ngClass]="{
                                    'bg-success': card.estado === 'liquidated',
                                    'bg-warning text-dark': card.estado === 'pending',
                                    'bg-info text-dark': card.estado === 'mixed'
                                }">
                                    {{ card.estado === "liquidated" ? "Informado por Payku" : card.estado === "mixed" ? "Mixto" : card.estado === "empty" ? "Sin movimientos" : "Pendiente" }}
                                </span>
                            </div>
							<div class="mt-3 text-end">
								<a href="#" (click)="viewDayDetail(card); $event.preventDefault()" class="text-decoration-none" [ngClass]="{ 'text-white': card.role === 'today', 'text-primary': card.role !== 'today' }"> Ver detalle <i class="fas fa-arrow-right ms-1"></i> </a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Subtítulo LIQUIDADOS + info -->
			<div class="row align-items-center mb-2">
				<div class="col-12 d-flex align-items-center">
					<h4 class="mb-0 me-2">Liquidados</h4>
					<i class="fas fa-circle-info text-muted" [ngbPopover]="liqInfo" popoverTitle="¿Qué significa 'Liquidados'?" triggers="mouseenter:mouseleave" placement="right" [popoverClass]="'payku-popover'"> </i>
					<ng-template #liqInfo>
                        <small>Corresponde a montos informados como liquidados por Payku. Es evidencia del proveedor, no comprobación bancaria; el detalle conserva bruto, comisión y neto reportado.</small>
					</ng-template>
				</div>
			</div>

			<!-- Mes anterior / actual / gráfico -->
			<div class="row mb-4 monthly-cards-container">
				<div class="col-lg-4 mb-3">
					<div class="card h-100">
						<div class="card-body">
							<h6 class="card-subtitle text-muted mb-2">Mes anterior</h6>
							<h5 class="card-title">{{ previousMonth.month }}</h5>
                            <div class="small">Cobrado bruto: $ {{ previousMonth.gross }}</div>
                            <div class="small">Neto estimado pendiente: $ {{ previousMonth.estimated }}</div>
                            <h4 class="mb-1">{{ previousMonth.incomplete ? 'Subtotal conocido' : 'Informado' }}: $ {{ previousMonth.reported }}</h4>
                            <div class="small text-warning" *ngIf="previousMonth.incomplete">{{ previousMonth.incomplete }} liquidación(es) sin importe. Total incompleto.</div>
							<div class="mt-3 text-end">
								<a href="#" (click)="viewMonthDetail(false); $event.preventDefault()" class="text-primary text-decoration-none"> Ver detalle <i class="fas fa-arrow-right ms-1"></i> </a>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-4 mb-3">
					<div class="card h-100">
						<div class="card-body">
							<h6 class="card-subtitle text-muted mb-2">Mes en curso</h6>
							<h5 class="card-title">{{ currentMonth.month }}</h5>
                            <div class="small">Cobrado bruto: $ {{ currentMonth.gross }}</div>
                            <div class="small">Neto estimado pendiente: $ {{ currentMonth.estimated }}</div>
                            <h4 class="mb-1">{{ currentMonth.incomplete ? 'Subtotal conocido' : 'Informado' }}: $ {{ currentMonth.reported }}</h4>
                            <div class="small text-warning" *ngIf="currentMonth.incomplete">{{ currentMonth.incomplete }} liquidación(es) sin importe. Total incompleto.</div>
							<div class="mt-3 text-end">
								<a href="#" (click)="viewMonthDetail(true); $event.preventDefault()" class="text-primary text-decoration-none"> Ver detalle <i class="fas fa-arrow-right ms-1"></i> </a>
							</div>
						</div>
					</div>
				</div>

				<div class="col-lg-4 mb-3">
					<div class="card h-100">
						<div class="card-body">
							<h6 class="card-subtitle text-muted mb-2">Últimos 6 meses</h6>
							<p class="small text-muted">{{ lastSixMonths.period }}</p>

							<div class="chart-container mt-3">
								<div class="d-flex justify-content-between align-items-end" style="height: 100px">
									<div *ngFor="let item of lastSixMonths.chartData" class="chart-bar text-center" style="flex: 1; margin: 0 2px">
										<div class="bar" [ngClass]="{ 'bg-primary': item.value > 0, 'bg-light': item.value === 0 }" [style.height.%]="getBarHeight(item.value)" [title]="'$' + formatCLPForTooltip(item.value)" style="margin-bottom: 5px; min-height: 3px; cursor: pointer"></div>
										<small class="text-muted" style="font-size: 10px"> {{ item.month.substring(0, 3) }}<br />{{ item.month.substring(4) }} </small>
									</div>
								</div>
							</div>

							<div class="d-flex justify-content-between mt-3">
								<div class="d-flex align-items-center justify-content-center mt-4">
									<div class="legend-item me-5 mr-5">
										<span class="badge bg-primary me-2"></span>
										<small>Total</small>
									</div>
									<div class="legend-item me-5 mr-5">
										<span class="badge bg-danger"></span>
										<small>Débito</small>
									</div>
									<div class="legend-item me-5 mr-5">
										<span class="badge bg-info me-2"></span>
										<small>Crédito</small>
									</div>
									<div class="legend-item">
										<span class="badge bg-warning me-2"></span>
										<small>Prepago</small>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- /monthly -->
		</div>

		<!-- Vista Administrador -->
		<div *ngIf="activeView === 'administrador' && permissions.getPermission('83-16').asignado" class="view-content">
			<div class="row admin-view-container" *ngIf="config?.termsAccepted === true">
				<div class="col-12">
					<div class="card mb-3 shadow-sm">
						<div class="card-body py-2">
							<div class="payku-status-row px-2 py-1">
								<div class="payku-status-copy">
									<h6 class="mb-0 fw-bold text-primary">Estado Payku</h6>
								</div>
								<div class="cs-pill" role="group" aria-label="Estado Payku">
									<button type="button" class="cs-pill__btn" [class.is-active]="config.paykuHabilitado" [attr.aria-pressed]="config.paykuHabilitado" [disabled]="loading" (click)="cambiarEstadoPayku(true)">Activo</button>
									<button type="button" class="cs-pill__btn" [class.is-active]="!config.paykuHabilitado" [attr.aria-pressed]="!config.paykuHabilitado" [disabled]="loading" (click)="cambiarEstadoPayku(false)">Desactivado</button>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<!-- Documentos con link/QR -->
						<div class="col-lg-6 mb-4">
							<div class="card h-100 shadow-sm">
								<div class="card-header bg-primary text-white">
									<i class="fas fa-file-alt me-2"></i>
									<h5 class="mb-0 ml-3">Documentos con link/QR</h5>
								</div>
								<div class="card-body">
									<p class="text-muted mb-3">
										<i class="fas fa-check-circle me-1"></i>
										los documentos seleccionados se les aplicará el link/QR para pagar con Payku en línea.
									</p>
									<div class="d-flex flex-wrap justify-content-between mt-4">
										<div *ngFor="let tipo of tiposDteDisponibles" class="form-check me-4 mb-2">
											<input class="form-check-input" type="checkbox" [id]="'tipoDte' + tipo.id" [checked]="tiposSeleccionados.has(tipo.id)" [disabled]="!config.paykuHabilitado || loading" (change)="onCheckTipoDte(tipo.id, $event)" />
											<label class="form-check-label" [for]="'tipoDte' + tipo.id">
												{{ tipo.nombre }}
											</label>
										</div>
									</div>

									<div class="mt-5 text-center">
										<button class="btn btn-outline-primary px-4" [disabled]="!config.paykuHabilitado || loading" (click)="guardarTiposDte()"><i class="fas fa-save me-2"></i>Guardar Tipos DTE</button>
									</div>
								</div>
							</div>
						</div>

						<!-- Correo notificaciones -->
						<div class="col-lg-6 mb-4">
							<div class="card h-100 shadow-sm">
								<div class="card-header bg-primary text-white">
									<i class="fas fa-envelope me-2"></i>
									<h5 class="mb-0 ml-3">Correo de notificaciones</h5>
								</div>
								<div class="card-body">
									<p class="text-muted mb-3">
										<i class="fas fa-bell me-1"></i>
										Este correo recibe alertas de pago/notificaciones de Payku.
									</p>

									<div class="input-group mb-3">
										<span class="input-group-text"><i class="fas fa-at"></i></span>
										<input type="email" class="form-control" [(ngModel)]="correoNotificacion" [disabled]="!config.paykuHabilitado || loading" placeholder="correo@empresa.cl" />
									</div>

									<div class="text-center">
										<button class="btn btn-outline-primary px-4" [disabled]="!config.paykuHabilitado || loading" (click)="guardarCorreo()"><i class="fas fa-save me-2"></i>Guardar Correo</button>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Datos bancarios -->
					<div class="row">
						<div class="col-12">
							<div class="card shadow-sm">
								<div class="card-header bg-primary text-white">
									<i class="fas fa-university me-2"></i>
									<h5 class="mb-0 ml-3">Datos bancarios</h5>
								</div>
								<div class="card-body">
									<div class="alert alert-light border-start border-4 border-secondary">
										<div class="d-flex align-items-center">
											<div class="flex-grow-1">
												<h6 class="alert-heading mb-2"><i class="fas fa-edit me-2"></i>Configuración bancaria</h6>
												<p class="mb-3">Puedes modificar los datos bancarios asociados a tu cuenta Payku.</p>
												<button class="btn btn-outline-primary" [disabled]="modalLoading || !config.paykuHabilitado" (click)="editarDatosBancarios()" *ngIf="permissions.getPermission('83-24').asignado"><i class="fas fa-pencil-alt me-2"></i>Editar datos bancarios</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- /datos bancarios -->
				</div>
			</div>

			<div class="row" *ngIf="config?.termsAccepted === false">
				<div class="col-12">
					<div class="alert alert-light border-warning border-2" style="background-color: white">
						<div class="d-flex align-items-start">
							<i class="fas fa-exclamation-triangle text-warning me-3 mr-3" style="font-size: 1.5em; margin-top: 2px"></i>
							<div>
								<h6 class="alert-heading mb-2 text-warning">Términos y condiciones no aceptados</h6>
								<p class="mb-2">Para continuar usando los servicios de Payku, debes aceptar los términos y condiciones.</p>
								<p class="mb-3">Por favor, comunícate con nuestro equipo de soporte para completar este proceso y poder acceder a todas las funcionalidades de Payku.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- /administrador -->

		<!-- Vista Detalle de Transacciones -->
		<div *ngIf="activeView === 'detalle-transacciones'" class="view-content">
			<section class="row">
				<div class="col-12">
					<div class="card card-custom">
						<div class="card-header">
							<h4 class="card-title">Transacciones - {{ detailDate | date: "dd/MM/yyyy" }}</h4>
							<div class="card-toolbar" *ngIf="!transactionLoading">Transacciones: {{ transactionsPage.totalElements }}</div>
						</div>
						<div class="card-body">
							<!-- Loading -->
							<div *ngIf="transactionLoading" class="text-center py-5">
								<div class="spinner-border text-primary" role="status"></div>
							</div>

                            <p class="small text-muted">
                                Los importes del cobro y del reporte se conservan sin recalcular. Las devoluciones se muestran por separado; su ajuste en el abono requiere confirmación de Payku.
                            </p>
                            <!-- Tabla -->
							<ngx-datatable
								#transactionTable
								*ngIf="componentStarted && !transactionLoading"
								class="material payku-transactions-table"
								[rows]="detailTransactions"
								[columnMode]="'force'"
								[headerHeight]="64"
								[footerHeight]="50"
								[rowHeight]="110"
								[externalPaging]="true"
								[count]="transactionsPage.totalElements"
								[offset]="transactionsPage.pageNumber"
								[limit]="transactionsPage.pageSize"
								(page)="setTransactionPage($event)"
								[externalSorting]="false"
								[sortType]="SortType.single"
								[messages]="{ emptyMessage: 'Sin transacciones para mostrar', totalMessage: 'Elementos totales', selectedMessage: false }">
								<!-- Fecha -->
								<ngx-datatable-column name="fecha" [width]="135" [minWidth]="120" [sortable]="true" [resizeable]="false">
									<ng-template ngx-datatable-header-template>
										<span class="payku-table-header">Fecha aplicable</span>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<div class="payku-date-cell">
											<div>{{ (row.fechaConfirmacion || row.fechaEstimada || row.fecha) | date: "dd/MM/yyyy" }}</div>
											<small class="text-muted">{{ (row.fechaConfirmacion || row.fechaEstimada || row.fecha) | date: "HH:mm:ss" }}</small>
										</div>
									</ng-template>
								</ngx-datatable-column>

								<!-- Monto original-->
								<ngx-datatable-column name="monto" [width]="115" [minWidth]="105" [sortable]="true" [resizeable]="false" [cellClass]="'payku-number-column'" [headerClass]="'payku-number-column'">
									<ng-template ngx-datatable-header-template>
										<span class="payku-table-header">Monto facturado</span>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<span class="payku-amount">$ {{ formatCLPForDisplay(row.monto || 0) }}</span>
									</ng-template>
								</ngx-datatable-column>
								<!-- Monto con comision descontada-->
								<ngx-datatable-column name="montoNetoEstimado" [width]="115" [minWidth]="105" [sortable]="true" [resizeable]="false" [cellClass]="'payku-number-column'" [headerClass]="'payku-number-column'">
									<ng-template ngx-datatable-header-template>
										<span class="payku-table-header">Neto estimado</span>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<span class="payku-amount">$ {{ formatCLPForDisplay(row.montoNetoEstimado || 0) }}</span>
									</ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column name="montoLiquidadoInformado" [width]="140" [minWidth]="125" [sortable]="true" [resizeable]="false" [cellClass]="'payku-number-column'" [headerClass]="'payku-number-column'">
                                    <ng-template ngx-datatable-header-template>
										<span class="payku-table-header">Informado por Payku</span>
                                    </ng-template>
                                    <ng-template ngx-datatable-cell-template let-row="row">
										<span class="payku-amount" *ngIf="row.montoLiquidadoInformado !== null && row.montoLiquidadoInformado !== undefined">$ {{ formatCLPForDisplay(row.montoLiquidadoInformado) }}</span>
                                        <span class="text-muted" *ngIf="row.montoLiquidadoInformado === null || row.montoLiquidadoInformado === undefined">{{ row.liquidacionSinImporte ? 'Sin dato' : '-' }}</span>
                                        <small class="d-block text-muted" *ngIf="row.fuenteImporte === 'legacy'">Registro histórico</small>
                                    </ng-template>
                                </ngx-datatable-column>
								<ngx-datatable-column name="devoluciones" [width]="165" [minWidth]="150" [sortable]="false" [resizeable]="false">
									<ng-template ngx-datatable-header-template><span class="payku-table-header">Devoluciones</span></ng-template>
                                    <ng-template ngx-datatable-cell-template let-row="row">
										<div class="payku-refund-cell">
											<div>Confirmado: $ {{ formatCLPForDisplay(row.montoDevuelto || 0) }}</div>
											<div>Pendiente: $ {{ formatCLPForDisplay(row.montoDevolucionPendiente || 0) }}</div>
											<div>Remanente: $ {{ formatCLPForDisplay(row.remanente) }}</div>
											<small *ngIf="row.devolucionRequiereRevision" class="text-warning">Requiere revisión</small>
										</div>
                                    </ng-template>
                                </ngx-datatable-column>
                                <!-- Estado -->
								<ngx-datatable-column name="estado" [width]="105" [minWidth]="95" [sortable]="true" [resizeable]="false" [cellClass]="'payku-status-column'" [headerClass]="'payku-status-column'">
									<ng-template ngx-datatable-header-template>
										<span class="payku-table-header">Estado</span>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<span
											class="badge"
											[ngClass]="{
												'bg-success': row.estado === 'liquidated' || row.estado === 'completado',
												'bg-warning text-dark': row.estado === 'pending' || row.estado === 'pendiente',
												'bg-danger': row.estado === 'failed' || row.estado === 'fallido'
											}">
											{{ getEstadoLabel(row.estado) }}
										</span>
									</ng-template>
								</ngx-datatable-column>

								<!-- RUT -->
								<ngx-datatable-column name="receptorRut" [width]="115" [minWidth]="105" [sortable]="false" [resizeable]="false">
									<ng-template ngx-datatable-header-template>
										<span class="payku-table-header">RUT Receptor</span>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<span class="payku-truncated-cell" [title]="row.receptorRut">
											{{ row.receptorRut || "-" }}
										</span>
									</ng-template>
								</ngx-datatable-column>

								<!-- Razón Social -->
								<ngx-datatable-column name="receptorRazonSocial" [width]="150" [minWidth]="135" [sortable]="false" [resizeable]="false">
									<ng-template ngx-datatable-header-template>
										<span class="payku-table-header">Razón Social</span>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<span class="payku-wrapped-cell" [title]="row.receptorRazonSocial">
											{{ row.receptorRazonSocial || "-" }}
										</span>
									</ng-template>
								</ngx-datatable-column>

								<!-- Acciones -->
								<ngx-datatable-column name="acciones" [width]="90" [minWidth]="90" [sortable]="false" [canAutoResize]="false" [resizeable]="false" [cellClass]="'payku-actions-column'" [headerClass]="'payku-actions-column'">
									<ng-template ngx-datatable-header-template>
										<span class="payku-table-header">Acciones</span>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<div class="btn-group btn-group-sm" role="group">
											<button type="button" class="btn btn-outline-primary" [disabled]="!row.dteFolio" [title]="row.dteFolio ? 'Ver DTE en documentos emitidos' : 'Sin folio DTE asociado'" (click)="navigateToDte(row)">
												<i class="fas fa-file-invoice"></i>
											</button>
										</div>
									</ng-template>
								</ngx-datatable-column>
							</ngx-datatable>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>

	<div class="row mt-4">
		<div class="col-12">
			<ng-container *ngTemplateOutlet="paykuInfoCards"></ng-container>
		</div>
	</div>
	<!-- /views -->
</div>

<!-- Modal editar datos bancarios (Administrador) -->
<ng-template #modalCuenta let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Editar datos bancarios</h5>
	</div>

	<div class="modal-body">
		<div class="alert alert-light border mb-3">
			<div class="d-flex align-items-center">
				<i class="fas fa-info-circle me-2 mr-3"></i>
				<div>
					<div class="small text-muted">Este módulo es para editar los datos bancarios asociados a tu cuenta Payku.</div>
				</div>
			</div>
		</div>
		<form (ngSubmit)="guardarCuentaBancaria(modal)" autocomplete="off">
			<div class="row g-3">
				<div class="col-md-6">
					<label class="form-label">Número de cuenta</label>
					<input class="form-control" [(ngModel)]="cuentaForm.numCuenta" name="numCuenta" required placeholder="Ej: 12345678" />
					<div class="form-text">Se guardará cifrado; solo se mostrará **** últimos 4.</div>
				</div>

				<div class="col-md-6">
					<label class="form-label">RUT titular</label>
					<input class="form-control" [(ngModel)]="cuentaForm.rut" name="rut" required placeholder="11.111.111-1" />
				</div>
				<div class="col-md-6">
					<label class="form-label">Banco</label>
					<ng-select [(ngModel)]="cuentaForm.sbif" name="sbif" placeholder="Selecciona un banco" bindLabel="nombre" bindValue="sbif" [items]="bancos" [searchable]="true" [clearable]="false" required>
						<ng-option *ngFor="let b of bancos" [value]="b.sbif"> {{ b.nombre }}</ng-option>
					</ng-select>
				</div>

				<div class="col-md-6">
					<label class="form-label">Tipo de cuenta</label>
					<ng-select [(ngModel)]="cuentaForm.tipoCuentaId" name="tipoCuentaId" placeholder="Selecciona tipo de cuenta" bindLabel="nombre" bindValue="tipoCuentaId" [items]="tiposCuenta" [searchable]="true" [clearable]="false" required>
						<ng-option *ngFor="let t of tiposCuenta" [value]="t.tipoCuentaId">
							{{ t.nombre }}
						</ng-option>
					</ng-select>
				</div>
			</div>

			<div class="mt-4 d-flex justify-content-end gap-3">
				<button type="button" class="btn btn-outline-secondary mr-3" [disabled]="modalLoading" (click)="modal.dismiss()">Cancelar</button>
				<button type="submit" class="btn btn-primary" [disabled]="modalLoading"><i class="fas fa-save me-2"></i>Guardar</button>
			</div>
		</form>
	</div>
</ng-template>
